import React, { useEffect, useState } from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import PlateBox from './PlateBox';
import PlatesSlider from './PlatesSlider';
import { getPlatesByIdServiceType } from '@shared/services/services';
import { sxPlatesList } from './styles';

// --- Cache por IdServiceType ---
const platesCache = {};

const PlatesList = ({ title, IdServiceType, section, typePlate }) => {
  const { site_functions } = useSelector(store => store.pageConfiguration);

  const [plates, setPlates] = useState([]);
  const [buscar, setBuscar] = useState('');

  useEffect(() => {
    fetchPlates();
  }, [IdServiceType]);

  const fetchPlates = async () => {
    if (platesCache[IdServiceType]) {
      setPlates(platesCache[IdServiceType]);
      return;
    }

    try {
      const result = await getPlatesByIdServiceType(IdServiceType);
      platesCache[IdServiceType] = result;
      setPlates(result);
    } catch (error) {
      console.error(error);
    }
  };

  const filterPlates = plates.filter(
    row =>
      row?.title?.toLowerCase().includes(buscar?.toLowerCase()) ||
      row?.info?.toLowerCase().includes(buscar?.toLowerCase())
  );

  if (!plates?.length) return null;

  return (
    <Grid
      id={IdServiceType === 4 ? 'scrollTo' : undefined}
      container
      justifyContent="flex-start"
      data-testid="placas_container"
    >
      <Grid
        item
        xs={12}
        sx={site_functions.searchCards ? sxPlatesList.filters : undefined}
      >
        {site_functions.searchCards ? (
          <Grid container sx={sxPlatesList.boxWhite}>
            <Grid item xs={4} md={6} sx={sxPlatesList.flex}>
              <Typography sx={sxPlatesList.title}>{title}</Typography>
            </Grid>
            <Grid item xs={8} md={6}>
              <TextField
                fullWidth
                size="small"
                placeholder={'Buscar ' + title}
                name="filter"
                value={buscar}
                onChange={val => setBuscar(val.target.value)}
                variant="outlined"
                sx={{ width: '95%', pl: '15px' }}
                style={{ marginTop: '15px' }}
              />
            </Grid>
          </Grid>
        ) : (
          <Typography sx={sxPlatesList.title}>{title}</Typography>
        )}
      </Grid>

      {!site_functions.showInModeGrid ? (
        <PlatesSlider
          filterPlates={filterPlates}
          section={section}
          typePlate={typePlate}
        />
      ) : (
        <Box sx={{ flexGrow: 1 }}>
          <Grid container item columns={15}>
            {filterPlates?.map(placa => (
              <Grid
                item
                key={placa.id}
                sx={{
                  maxWidth: {
                    xs: '100%',
                    sm: '50%',
                    md: '33%',
                    lg: '25%',
                    xl: '20%',
                  },
                  flexBasis: {
                    xs: '100%',
                    sm: '50%',
                    md: '33%',
                    lg: '25%',
                    xl: '20%',
                  },
                }}
                xs={12}
                sm={6}
                md={4}
                lg={3}
              >
                <PlateBox data={placa} typePlate={typePlate} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Grid>
  );
};

export default PlatesList;
